import React from 'react'
import { Autoplay, EffectFade, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import styles from './HeroSlider.module.scss'
import { HeroSliderPicture, HeroSliderTypes } from './HeroSlider.types'

const HeroSlider = (props: HeroSliderTypes) => {
  const { images = [], speed, autoplay, onChange } = props

  // set css variables for swiper bullet
  document.documentElement.style.setProperty(
    '--bullet-transition',
    `${autoplay && autoplay.delay ? autoplay.delay / 1000 : 0}s`
  )

  return (
    <div className='HeroSlider'>
      <Swiper
        // install Swiper modules
        modules={[Pagination, EffectFade, Autoplay]}
        slidesPerView={1}
        loop={true}
        pagination={{ clickable: true }}
        effect='fade'
        allowTouchMove={false}
        autoplay={autoplay}
        fadeEffect={{
          crossFade: true,
        }}
        speed={speed}
        onSlideChange={onChange}
      >
        {images.map((img: string | HeroSliderPicture, index) => {
          if (typeof img === 'string') {
            return (
              <SwiperSlide key={index}>
                <img src={img} alt='Изображение Комплекса' />
              </SwiperSlide>
            )
          }

          return (
            <SwiperSlide
              key={index}
              className={img.class ? styles[img.class] : ''}
            >
              <picture>
                <source media='(max-width: 1024px)' srcSet={img.mob} />
                <img src={img.desk} alt='Изображения в галереи' />
              </picture>
            </SwiperSlide>
          )
        })}
      </Swiper>
    </div>
  )
}

export default HeroSlider
